export default __webpack_public_path__ + "6afaee86f4fdae441dc47fdc68e94cb2.svg";